import styled, { keyframes } from 'styled-components';

const entradaSuave = keyframes`
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const brilho = keyframes`
  0% {
    transform: translateX(-30%);
    opacity: 0;
  }
  40% {
    opacity: 0.35;
  }
  100% {
    transform: translateX(130%);
    opacity: 0;
  }
`;

export const pagina = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-bottom: 56px;
  background:
    radial-gradient(circle at 15% 25%, rgba(20, 118, 255, 0.12), transparent 45%),
    radial-gradient(circle at 80% 15%, rgba(0, 182, 122, 0.16), transparent 48%),
    linear-gradient(140deg, #081017 0%, #0d1820 35%, #101010 100%);
  color: #eaf4ff;

  @media (max-width: 980px) {
    padding-bottom: 64px;
  }
`;

export const miolo = styled.main`
  width: min(1180px, calc(100% - 120px));
  margin-top: 74px;
  margin-left: clamp(110px, 12vw, 170px);
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
  animation: ${entradaSuave} 0.35s ease;

  @media (max-width: 980px) {
    width: min(1180px, calc(100% - 28px));
    margin-left: 0;
    margin-top: 108px;
    margin-bottom: 0;
  }
`;

export const hero = styled.section`
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(90, 205, 165, 0.35);
  border-radius: 20px;
  padding: 22px;
  background: linear-gradient(120deg, rgba(8, 25, 40, 0.88), rgba(12, 50, 35, 0.65));

  h1 {
    margin: 0;
    font-size: clamp(24px, 3vw, 34px);
    letter-spacing: 0.3px;
    color: #dff7ed;
  }

  p {
    margin: 10px 0 0;
    color: #b6d2e5;
    max-width: 780px;
    line-height: 1.5;
    font-size: clamp(13px, 1.8vw, 15px);
  }

  &::after {
    content: '';
    position: absolute;
    top: -20%;
    left: -25%;
    width: 36%;
    height: 140%;
    background: linear-gradient(110deg, transparent 0%, rgba(111, 229, 183, 0.3) 48%, transparent 100%);
    animation: ${brilho} 5s ease-in-out infinite;
    pointer-events: none;
  }
`;

export const grade = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  > *:only-child {
    grid-column: 1 / -1;
  }

  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
  }
`;

export const card = styled.section`
  border: 1px solid rgba(79, 133, 160, 0.45);
  border-radius: 18px;
  background: linear-gradient(180deg, rgba(6, 20, 31, 0.82), rgba(8, 17, 23, 0.94));
  box-shadow: 0 16px 34px rgba(3, 8, 12, 0.32);
  padding: 18px;

  @media (max-width: 780px) {
    padding: 14px;
  }

  h2 {
    margin: 0;
    color: #f4fbff;
    font-size: clamp(18px, 2vw, 23px);
  }

  > p {
    margin: 8px 0 0;
    color: #afc8db;
    font-size: 14px;
    line-height: 1.45;
  }
`;

export const gradeCampos = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 14px;

  @media (max-width: 780px) {
    grid-template-columns: 1fr;
  }
`;

export const campo = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #c6daea;
  font-size: 13px;
  min-width: 0;

  input,
  select,
  textarea {
    width: 100%;
    min-height: 40px;
    border-radius: 10px;
    border: 1px solid #295369;
    background: rgba(4, 13, 18, 0.88);
    color: #e6f7ff;
    padding: 9px 10px;
    outline: none;
    font-size: 13px;
    box-sizing: border-box;
  }

  textarea {
    min-height: 94px;
    resize: vertical;
  }

  input:focus,
  select:focus,
  textarea:focus {
    border-color: #57d5a0;
    box-shadow: 0 0 0 2px rgba(87, 213, 160, 0.2);
  }
`;

export const campoTopo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const campoTitulo = styled.span`
  color: #cfe4f2;
  line-height: 1.2;
`;

export const ajudaBotao = styled.button`
  width: 18px;
  height: 18px;
  min-width: 18px;
  border-radius: 50%;
  border: 1px solid #4aa6d5;
  background: rgba(10, 35, 50, 0.95);
  color: #8ed4fb;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  line-height: 1;

  &:hover {
    filter: brightness(1.1);
  }
`;

export const ajudaTexto = styled.small`
  margin-top: -2px;
  color: #9cc2d8;
  background: rgba(16, 34, 47, 0.85);
  border: 1px solid #2c556c;
  border-radius: 8px;
  padding: 7px 8px;
  line-height: 1.35;
`;

export const linhaAcoes = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 14px;
`;

export const resumoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;

  @media (max-width: 780px) {
    grid-template-columns: 1fr;
  }
`;

export const resumoItem = styled.div`
  border: 1px solid #2d5368;
  border-radius: 10px;
  background: rgba(10, 24, 34, 0.85);
  padding: 9px 10px;
`;

export const resumoTitulo = styled.div`
  color: #9fc0d4;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

export const resumoValor = styled.div`
  margin-top: 4px;
  color: #def0fb;
  font-size: 13px;
  line-height: 1.3;
  overflow-wrap: anywhere;
`;

export const botao = styled.button`
  min-height: 42px;
  border-radius: 10px;
  padding: 0 14px;
  border: 1px solid ${({ $variant }) => ($variant === 'primario' ? '#49d09a' : '#2f627c')};
  background: ${({ $variant }) => ($variant === 'primario' ? '#0f7f58' : '#102431')};
  color: #effbff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.18s ease, filter 0.18s ease;

  &:hover {
    transform: translateY(-1px);
    filter: brightness(1.06);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

export const blocoStatus = styled.div`
  margin-top: 14px;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid ${({ $tipo }) => ($tipo === 'erro' ? '#c75151' : '#2b8f66')};
  background: ${({ $tipo }) => ($tipo === 'erro' ? 'rgba(145, 38, 38, 0.24)' : 'rgba(23, 86, 62, 0.3)')};
  color: ${({ $tipo }) => ($tipo === 'erro' ? '#ffdede' : '#d8ffe8')};
  font-size: 13px;
  line-height: 1.4;
  overflow-wrap: anywhere;
`;

export const quadroRequisitos = styled.div`
  margin-top: 14px;
  border-radius: 12px;
  border: 1px solid #25485c;
  background: rgba(7, 17, 23, 0.8);
  padding: 12px;

  h3 {
    margin: 0;
    font-size: 14px;
    color: #deeffa;
  }
`;

export const checklist = styled.div`
  display: grid;
  gap: 8px;
  margin-top: 10px;

  input[type='checkbox'] {
    margin-top: 1px;
    accent-color: #49d09a;
  }
`;

export const etapaChecklist = styled.section`
  margin-top: 12px;
  padding-top: 8px;

  &:not(:first-child) {
    border-top: 1px dashed #2d4d60;
  }
`;

export const etapaChecklistTitulo = styled.h4`
  margin: 0;
  color: #dff3ff;
  font-size: 13px;
  letter-spacing: 0.2px;
`;

export const checkItem = styled.label`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: start;
  gap: 8px;
  color: ${({ $ok }) => ($ok ? '#caefdd' : '#ffc5c5')};
  font-size: 13px;
  line-height: 1.4;
  border: 1px solid ${({ $ok }) => ($ok ? '#2f7a59' : '#8d3a3a')};
  border-radius: 8px;
  padding: 8px;
  background: ${({ $ok }) => ($ok ? 'rgba(29, 95, 68, 0.22)' : 'rgba(103, 36, 36, 0.2)')};

  span {
    min-width: 0;
    padding-top: 1px;
  }

  input[type='checkbox'] {
    pointer-events: none;
  }

  @media (max-width: 780px) {
    grid-template-columns: auto 1fr;
  }
`;

export const statusTag = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
  border-radius: 999px;
  padding: 0 10px;
  border: 1px solid ${({ $ok }) => ($ok ? '#4ec892' : '#dc6262')};
  color: ${({ $ok }) => ($ok ? '#d6ffeb' : '#ffd9d9')};
  background: ${({ $ok }) => ($ok ? 'rgba(50, 149, 102, 0.34)' : 'rgba(154, 53, 53, 0.32)')};
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;

  @media (max-width: 780px) {
    grid-column: 2;
    justify-self: start;
  }
`;

